<template>
    <div>
        <az-back-button style="margin-top: 20px !important;" :route="{name: rotaOrigem}" text="Voltar para listagem"/>
        <az-container>
            <div class="az-tabs de-abas">
                <v-tabs left class="de-abas__area">
                    <div class="de-info">
                        <p>
                            <strong>Processo:</strong> {{dadosGerais.processo}}
                            <span v-if="dadosGerais.quantidadeRepeticoes">
                                - <strong>Repetição:</strong> {{dadosGerais.quantidadeRepeticoes}}
                            </span>
                        </p>
                        <p><strong>Situação:</strong> {{dadosGerais.situacao | azEnum(situacoesCompraDireta)}}</p>
                    </div>
                    <div>
                        <v-tab v-for="aba in abas"
                               :key="aba.ordem"
                               :to="construirRota(aba)"
                               exact
                               exact-active-class="active"
                               :disabled="desabilitarAbaConformeSituacao(aba)"
                               class="de-abas__item">
                            <span class="de-abas__badge">{{aba.ordem}}</span>
                            {{aba.titulo}}
                        </v-tab>
                    </div>
                    <div class="actions menu-opcoes">
                        <v-menu offset-y left v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'">
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list class="lista-menu">
                                <acoes-exportar-resultado v-if="dadosGerais.situacao === 'ENCERRADA'"
                                                          :resultadoExportado="compraDiretaExportado"
                                                        @exportarResultado="tratarEventoExportarResultado"/>
                                <acoes-envios-remessa v-if="dadosGerais.deveHabilitarEnvioEsfinge"
                                                        :numeroProtocolo="numeroProtocolo"
                                                        @processarPrimeiroEnvioDispensaEsfinge="primeiroEnvioDispensaEsfinge"
                                                        @processarEnviarAlterarDispensaEsfinge="enviarAlterarDispensaEsfinge"
                                                        @processarModalProtocoloDispensaEsfinge="exibicaoModalProtocoloDispensaEsfinge"
                                                        @processarCancelarDispensaEsfinge="cancelarDispensaEsfinge"/>
                                <acoes-envios-ocorrencia v-if="dadosGerais.deveHabilitarEnvioOcorrenciaEsfinge"
                                                      :numeroProtocoloOcorrencia="numeroProtocoloOcorrencia"
                                                      @processarAbrirModalFormalarioOcorrenciaEsfinge="abrirModalFormalarioOcorrenciaEsfinge"/>
                                <acoes-anular v-if="compraDiretaEmExecucao"
                                              :compraDiretaId="compraDiretaId"/>
                                <acoes-revogar v-if="compraDiretaEmExecucao"
                                               :compraDiretaId="compraDiretaId"/>
                                <acoes-cancelar v-if="compraDiretaEmExecucao"
                                                :compraDiretaId="compraDiretaId"/>
                                <acoes-fracassar v-if="compraDiretaEmExecucao"
                                                 :compraDiretaId="compraDiretaId"/>
                                <acoes-suspender v-if="exibirAcoesSuspensao"
                                                 :compraDiretaId="compraDiretaId"/>
                                <acoes-retomar v-if="dadosGerais.situacao === 'SUSPENSA'"
                                               :compraDiretaId="compraDiretaId"
                                               :suspensaoPosAnalise="dadosGerais.suspensaoPosAnalise"
                                               @compraDiretaRetomada="buscarDadosGeraisEResumo"/>
                                <acoes-prorrogar v-if="dadosGerais.situacao === 'ABERTA'"
                                                 :dadosGerais="dadosGerais"
                                                 :exibirFimEnvioPropostasELances="exibirFimEnvioPropostasELances"
                                                 @confirmarProrrogacao="prorrogarCompraDireta"/>
                                <acoes-despublicar v-if="(dadosGerais.situacao === 'ABERTA' || dadosGerais.situacao === 'AGUARDANDO_ABERTURA')
                                                            && !dadosGerais.possuiPropostasEnviadas"
                                                   :compraDiretaId="compraDiretaId"
                                                   @confirmarDespublicacao="despublicarCompraDireta"/>
                                <acoes-excluir v-if="dadosGerais.situacao === 'EM_ELABORACAO'"
                                               @excluirCompraDireta="tratarEventoExcluir"/>

                                <acoes-exportar-mais-brasil v-if="dadosGerais.tipoTransferencia !== 'OUTRAS' && dadosGerais.recursoFederal === true
                                && dadosGerais.situacao !== 'EM_ELABORACAO'"
                                                            @exportarMaisBrasil="exportarMaisBrasil"/>
                                <acoes-baixar-relatorio-mais-brasil v-if="dadosGerais.tipoTransferencia !== 'OUTRAS' && dadosGerais.recursoFederal === true
                                && dadosGerais.situacao !== 'EM_ELABORACAO'"
                                                                    @baixar="baixarRelatorioMaisBrasil"/>
                            </v-list>
                        </v-menu>
                    </div>
                </v-tabs>

                <transition name="fade" mode="out-in">
                    <router-view/>
                </transition>
            </div>
        </az-container>

        <mensagem-alerta :exibirMensagem="mostrarModalProtocoloDispensaEsfinge"
                         titulo="Número de Protocolo"
                         :textoSecundario="numeroProtocolo"
                         tamanhoMaximo="500"
                         com-botao-confirmar
                         botaoConfirmar="Fechar"
                         @confirmado="mostrarModalProtocoloDispensaEsfinge = false"/>

        <modal-formulario-ocorrencia-esfinge
            v-if="mostrarModalFormalarioOcorrenciaEsfinge"
            :exibirModal="mostrarModalFormalarioOcorrenciaEsfinge"
            @processarEnviarAlterarOcorrencia="enviarAlterarOcorrenciaEsfinge"
            @processarFecharModal="fecharModalFormularioOcorrenciaEsfinge"
        ></modal-formulario-ocorrencia-esfinge>
    </div>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import {actionTypes, mutationTypes, situacoesCompraDireta} from '@/core/constants'
import AcoesAnular from '@/views/pages/comprador/execucao-compra-direta/acoes/AcoesAnular'
import AcoesExcluir from '@/views/pages/comprador/execucao-compra-direta/acoes/AcoesExcluir'
import AcoesExportarResultado from '@/views/pages/comprador/execucao-compra-direta/acoes/AcoesExportarResultado'
import AcoesCancelar from '@/views/pages/comprador/execucao-compra-direta/acoes/AcoesCancelar'
import AcoesFracassar from '@/views/pages/comprador/execucao-compra-direta/acoes/AcoesFracassar'
import AcoesRevogar from '@/views/pages/comprador/execucao-compra-direta/acoes/AcoesRevogar'
import AcoesSuspender from '@/views/pages/comprador/execucao-compra-direta/acoes/AcoesSuspender'
import AcoesRetomar from '@/views/pages/comprador/execucao-compra-direta/acoes/AcoesRetomar'
import AcoesDespublicar from './acoes/AcoesDespublicar'
import AcoesProrrogar from './acoes/AcoesProrrogar'
import AcoesExportarMaisBrasil from './acoes/AcoesExportarMaisBrasil'
import AcoesBaixarRelatorioMaisBrasil from './acoes/AcoesBaixarRelatorioMaisBrasil'
import AcoesEnviosRemessa from './acoes/AcoesEnviosRemessa'
import AcoesEnviosOcorrencia from './acoes/AcoesEnviosOcorrencia'
import MensagemAlerta from '@/views/components/MensagemAlerta'
import ModalFormularioOcorrenciaEsfinge from './acoes/ModalFormularioOcorrenciaEsfinge'

export default {
    name: 'ExecucaoCompraDireta',
    mixins: [SmartTimerMixin],
    components: {
        AcoesBaixarRelatorioMaisBrasil,
        AcoesExportarMaisBrasil,
        AcoesProrrogar,
        AcoesDespublicar,
        AcoesEnviosRemessa,
        AcoesEnviosOcorrencia,
        AcoesAnular, 
        AcoesExcluir,
        AcoesExportarResultado,
        AcoesCancelar,
        AcoesFracassar,
        AcoesRevogar,
        AcoesSuspender,
        AcoesRetomar,
        MensagemAlerta,
        ModalFormularioOcorrenciaEsfinge},
    data() {
        return {
            abas: [
                {
                    titulo: 'Dados Gerais',
                    rotaPadrao: 'DadosGeraisVisualizacao',
                    rotaEdicao: 'DadosGeraisEdicao',
                    situacoesEdicao: ['EM_ELABORACAO'],
                    ordem: 1
                },
                {
                    titulo: 'Itens',
                    rotaPadrao: 'ItensLotesVisualizacao',
                    rotaEdicao: 'ItensLotesEdicao',
                    situacoesEdicao: ['EM_ELABORACAO'],
                    ordem: 2
                },
                {
                    titulo: 'Documentos',
                    rotaPadrao: 'DocumentosVisualizacao',
                    rotaEdicao: 'DocumentosEdicao',
                    situacoesEdicao: ['EM_ELABORACAO'],
                    ordem: 3
                },
                {
                    titulo: 'Acompanhamento',
                    rotaPadrao: 'AcompanhamentoVisualizacao',
                    situacoesParaAcessar: ['AGUARDANDO_ABERTURA', 'ABERTA', 'ENCERRADA', 'EM_ANALISE', 'REANALISE', 'SUSPENSA'],
                    ordem: 4
                },
                {
                    titulo: 'Resultado',
                    rotaPadrao: 'Resultado',
                    situacoesParaAcessar: ['ENCERRADA', 'EM_ANALISE', 'REANALISE'],
                    ordem: 5
                }
            ],
            compraDiretaId: null,
            envioEsfinge: {},
            mostrarModalProtocoloDispensaEsfinge: false,
            envioOcorrenciaEsfinge: {},
            mostrarModalFormalarioOcorrenciaEsfinge: false,
            permitirEnviarOcorrenciaEsfinge: false,
            rotaOrigem: this.$store.state.rota.origem,
            situacoesCompraDireta
        }
    },
    computed: {
        ...mapState(['loki', 'dadosGerais', 'resumoCompraDireta', 'parametros']),
        compraDiretaEmExecucao(){
            return ['ABERTA', 'EM_ANALISE','REANALISE'].includes(this.dadosGerais.situacao)
        },
        exibirFimEnvioPropostasELances() {
            return this.exibirFimPropostasELances(this.dadosGerais.amparoLegal)
        },
        compraDiretaExportado(){
            return this.resumoCompraDireta.resultadoExportado && this.resumoCompraDireta.origem === 'CP_PREP'
        },
        numeroProtocolo() {
            return this.dadosGerais.numeroProtocoloEsfinge
        },
        numeroProtocoloOcorrencia() {
            return this.dadosGerais.numeroProtocoloOcorrenciaEsfinge
        },
        ehPerfilVisualizador(){
            return (this.$store.state.loki.user.authorities.length === 1 &&
                this.$store.state.loki.user.authorities.includes('Comprador.Consulta'))
        },
        exibirAcoesSuspensao() {
            return (this.dadosGerais.situacao === 'ABERTA' ||
              this.dadosGerais.situacao === 'EM_ANALISE' ||
              this.dadosGerais.situacao === 'REANALISE' ||
              this.dadosGerais.situacao === 'AGUARDANDO_ABERTURA') &&
          !(this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII)
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.resumoCompraDireta?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
    },
    async beforeRouteUpdate(to, from, next) {
        try {
            if(from.name === to.name && to.params.id < from.params.id) {
                return
            }
            else if((from.path.includes('visualizacao') || from.path.includes('resultado'))
                && to.path.includes('edicao') || from.params.id !== to.params.id) {
                this.setCompraDiretaId()
                await this.buscarDadosGeraisEResumo()
                next()
                location.reload()
            }
            else{
                this.setCompraDiretaId()
                await this.buscarDadosGeraisEResumo()
                next()
            }
        } catch (e) {
            if (e.message.includes('is undefined')) {
                this.mostrarNotificacaoErroDefaultEReload()
            } else {
                this.mostrarNotificacaoErro(e.message)
            }
        }
    },
    async created() {
        try {
            this.setCompraDiretaId()
            await this.buscarDadosGeraisEResumo()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    mounted() {
        this.$store.commit(mutationTypes.SET_RETRAIR_MENU)
        
        this.createSmartTimer('verificarSituacaoDaCompraDireta', 'verificarSituacaoDaCompraDireta', 60000, {
            autostart: true,
            immediate: true
        })
    },
    methods: {
        async despublicarCompraDireta({compraDiretaId, motivo}){
            await this.$store.dispatch(actionTypes.COMPRADOR.DESPUBLICAR_COMPRA_DIRETA, {compraDiretaId, motivo})
            this.mostrarNotificacaoSucesso('Compra direta despublicada com sucesso. Você será redirecionado para a tela de dados gerais.')
            setTimeout(() => {
                this.$router.push({name: 'DadosGeraisEdicao'})
            },5000)
        },
        async prorrogarCompraDireta({compraDiretaId, motivo, dataHoraAtualizada}){
            await this.$store.dispatch(actionTypes.COMPRADOR.PRORROGAR_COMPRA_DIRETA, {compraDiretaId, motivo, dataHoraAtualizada})
            this.mostrarNotificacaoSucesso('Compra direta prorrogada com sucesso. A página será atualizada automaticamente.')
            setTimeout(() => {
                this.$router.go()
            },5000)
        },
        async buscarDadosGeraisEResumo() {
            this.setMensagemLoading('Carregando dados da compra direta...')
            await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS, this.compraDiretaId)
            await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        async tratarEventoExcluir() {
            await this.$store.dispatch(actionTypes.REMOVER_COMPRA_DIRETA, { compraDiretaId: this.compraDiretaId, removerNaOrigem: true })
            this.mostrarNotificacaoSucesso('Compra direta excluída com sucesso.')
            this.$router.push({
                name: this.rotaOrigem,
                query: { ...this.$route.query, skipConfirmExit: 'true' }
            })
        },
        async tratarEventoExportarResultado() {
            if(this.resumoCompraDireta.origem === 'SGC')
                await this.$store.dispatch(actionTypes.EXPORTAR_COMPRA_DIRETA, this.compraDiretaId)
            else
                await this.$store.dispatch(actionTypes.EXPORTAR_RESULTADOS_COMPRAS_PREPARACAO, this.compraDiretaId)

            this.mostrarNotificacaoSucesso('Compra direta exportada com sucesso.')
            this.$router.push({name: this.rotaOrigem})
        },
        async exportarMaisBrasil(situacao) {
            this.setMensagemLoading('Exportando dados...')
            const {mensagemSucesso} = await this.$store.dispatch(actionTypes.EXPORTAR_COMPRA_DIRETA_MAIS_BRASIL,
                {compraDiretaId: this.compraDiretaId, situacao: situacao}
            )
            this.mostrarNotificacaoSucesso(mensagemSucesso)
        },
        async baixarRelatorioMaisBrasil(){
            this.setMensagemLoading('Baixando relatório...')
            await this.$store.dispatch(actionTypes.BAIXAR_RELATORIO_MAIS_BRASIL, {compraDiretaId: this.compraDiretaId})
        },
        construirRota(aba) {
            if(this.ehPerfilVisualizador) {
                return {
                    name: aba.rotaPadrao,
                    params: {id: this.compraDiretaId},
                    query: this.$route.query
                }
            }

            let name = aba.rotaPadrao
            const forcarVisualizacaoSuspensa = (aba.titulo === 'Itens' || aba.titulo === 'Documentos') && 
                                               this.dadosGerais.situacao === 'SUSPENSA' && 
                                               this.dadosGerais.suspensaoPosAnalise === true
            const compraSuspensa = this.dadosGerais.situacao === 'SUSPENSA'
            
            if (azAuth(this.$store.state.loki.user.authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior'])
                && aba.rotaEdicao
                && aba.situacoesEdicao.includes(this.dadosGerais.situacao)
                && !forcarVisualizacaoSuspensa
                && !compraSuspensa) {
                name = aba.rotaEdicao
            }
            return {
                name,
                params: {id: this.compraDiretaId},
                query: this.$route.query
            }
        },
        verificarSituacaoDaCompraDireta() {
            if (this.dadosGerais.situacao === 'ABERTA') {
                this.buscarDadosGeraisEResumo()
            }
        },
        desabilitarAbaConformeSituacao(aba) {
            if (aba.titulo === 'Resultado' && this.dadosGerais.situacao === 'SUSPENSA' && this.dadosGerais.suspensaoPosAnalise === true) {
                return false
            }
            return aba.situacoesParaAcessar && !aba.situacoesParaAcessar.includes(this.dadosGerais.situacao)
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        verificarCompraDiretaEncerrada(situacao) {
            return situacao === 'ENCERRADA'
        },
        async primeiroEnvioDispensaEsfinge() {
            const data = await this.$store.dispatch(actionTypes.ESFINGE.ENVIAR_DISPENSA, this.compraDiretaId)

            if (data.enviadoComSucesso)
                this.mostrarNotificacaoSucesso('Enviado a Dispensa para o E-SFINGE com sucesso.')
            else
                this.mostrarNotificacaoErro('Erro ao Enviar a Dispensa para o E-SFINGE.')

            await this.buscarDadosGeraisEResumo()
        },
        async enviarAlterarDispensaEsfinge() {
            await this.buscarDispensaEsfinge()

            if (this.envioEsfinge.permitirEnviar && !this.envioEsfinge.enviandoAnexos) {
                const data = await this.$store.dispatch(actionTypes.ESFINGE.ENVIAR_DISPENSA, this.compraDiretaId)

                if (data.enviadoComSucesso)
                    this.mostrarNotificacaoSucesso('Enviado a Dispensa para o E-SFINGE com sucesso.')
                else
                    this.mostrarNotificacaoErro('Erro ao Enviar a Dispensa para o E-SFINGE.')
            } else if (!this.envioEsfinge.permitirEnviar && !this.envioEsfinge.enviandoAnexos) {
                const data = await this.$store.dispatch(actionTypes.ESFINGE.ALTERAR_DISPENSA, this.compraDiretaId)

                if (data.alteradoComSucesso)
                    this.mostrarNotificacaoSucesso('Reenviado a Dispensa para o E-SFINGE com sucesso.')
                else
                    this.mostrarNotificacaoErro('Erro ao Reenviar a Dispensa para o E-SFINGE.')
            } else {
                this.mostrarNotificacaoErro('Não foi possivel realizar a ação no momento.')
            }
        },
        async cancelarDispensaEsfinge() {
            await this.buscarDispensaEsfinge()

            if (this.envioEsfinge.permitirCancelarEnvio) {
                const data = await this.$store.dispatch(actionTypes.ESFINGE.CANCELAR_DISPENSA, this.compraDiretaId)

                if (data.canceladoComSucesso)
                    this.mostrarNotificacaoSucesso('Cancelamento da Dispensa no E-SFINGE realizado com sucesso.')
                else
                    this.mostrarNotificacaoErro('Erro ao Cancelar a Dispensa para o E-SFINGE.')
            } else {
                this.mostrarNotificacaoErro('Não é possivel realizar o Cancelamento da Dispensa no E-SFINGE no momento.')
            }
        },
        async exibicaoModalProtocoloDispensaEsfinge() {
            this.mostrarModalProtocoloDispensaEsfinge = true
        },
        async buscarDispensaEsfinge() {
            if (this.numeroProtocolo) {
                const data = await this.$store.dispatch(actionTypes.ESFINGE.BUSCAR_DISPENSA, this.compraDiretaId)
                this.envioEsfinge = data
            }
        },
        async enviarAlterarOcorrenciaEsfinge(dados) {
            await this.buscarOcorrenciaEsfinge()

            if (this.envioOcorrenciaEsfinge.permitirEnviar || this.permitirEnviarOcorrenciaEsfinge) {
                const data = await this.$store.dispatch(actionTypes.ESFINGE.ENVIAR_OCORRENCIA, {
                    compraDiretaId: this.compraDiretaId,
                    ...dados
                })

                if (data.enviadoComSucesso)
                    this.mostrarNotificacaoSucesso('Enviado a Ocorrencia para o E-SFINGE com sucesso.')
                else
                    this.mostrarNotificacaoErro('Erro ao Enviar a Ocorrencia para o E-SFINGE.')

            } else if (!this.envioOcorrenciaEsfinge.permitirEnviar) {
                const data = await this.$store.dispatch(actionTypes.ESFINGE.ALTERAR_OCORRENCIA, {
                    compraDiretaId: this.compraDiretaId,
                    ...dados
                })

                if (data.alteradoComSucesso)
                    this.mostrarNotificacaoSucesso('Reenviado a Ocorrencia para o E-SFINGE com sucesso.')
                else
                    this.mostrarNotificacaoErro('Erro ao Reenviar a Ocorrencia para o E-SFINGE.')
            } else {
                this.mostrarNotificacaoErro('Não foi possivel realizar a ação no momento.')
            }

            await this.buscarDadosGeraisEResumo()
        },
        async buscarOcorrenciaEsfinge() {
            if (this.numeroProtocoloOcorrencia) {
                const data = await this.$store.dispatch(actionTypes.ESFINGE.BUSCAR_OCORRENCIA, this.numeroProtocoloOcorrencia)
                this.envioOcorrenciaEsfinge = data
                this.permitirEnviarOcorrenciaEsfinge = false
            } else {
                this.permitirEnviarOcorrenciaEsfinge = true
            }
        },
        abrirModalFormalarioOcorrenciaEsfinge() {
            this.mostrarModalFormalarioOcorrenciaEsfinge = true
        },
        fecharModalFormularioOcorrenciaEsfinge() {
            this.mostrarModalFormalarioOcorrenciaEsfinge = false
        },
    },
    destroyed() {
        this.$store.commit(mutationTypes.SET_EXPANDIR_MENU)
    }
}
</script>

<style scoped lang="stylus">
    .de-abas__item
        cursor pointer

    .menu-opcoes
        width 50px
</style>
